ready(function(){
  // -- varibales --
  const $body = document.querySelector('body');
  const $portraitsLinks = document.querySelectorAll('.cardPortrait');

  // -- listeners --
  if ($portraitsLinks.length) {
    $portraitsLinks.forEach((link) => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
      });
    });
    document.addEventListener('htmx:afterRequest', function(e) {
      // console.log(e.target);
      // if (e.target.parentElement.classList.contains('glide__slide--active')) {
        openModal();
        const $closeModalBtn = document.querySelector('.btn--closeModal');
        $closeModalBtn.addEventListener('click', closeModal);
      // }
    });
  }

  // -- functions --
  function openModal() {
    setTimeout(function(){
      const $modalInner = document.querySelector('.modal .modal__inner');
      gsap.to("#modal", 1, {'autoAlpha': 1, 'pointer-events': 'all', 'top': 0, 'ease': 'power4.out'});
      $body.classList.add('overflow-hidden');
      $modalInner.focus();
      mountGlideGalleriesTypeSlider();
      reinitCursor();
    }, 600);
  }
  function closeModal() {
    gsap.to("#modal", 1, {'autoAlpha': 0, 'pointer-events': 'none', 'top': '100%', 'ease': 'power4.out'});
    $body.classList.remove('overflow-hidden');
    setTimeout(function(){
      const $modalInner = document.querySelector('.modal .modal__inner');
      // const $activeEl = document.querySelector('.glide__slide--active');
      $modalInner.remove();
      // $activeEl.focus();
    }, 800);
  }

});